export const TIME_TO_SLIDE = 500;
export const CLOSE_TIME_TO_SLIDE = 1000;

export const TIME_TO_CLOSE_TOOLTIP = 500;

export const ANIMATIONS = {
  SLIDE_IN_RIGHT: 'slideInRight',
  SLIDE_OUT_RIGHT: 'slideOutRight',
  SLIDE_IN_BOTTOM: 'slideInBottom',
  SLIDE_OUT_BOTTOM: 'slideOutBottom'
};
